module.exports = __webpack_public_path__ + "static/media/47.79a0dc82.png";